//

import { CustomGroup, MemberAlias, MemberMap } from '@nextforce/api'
import React, { createContext, useContext, useState } from 'react'

export type CustomGroupContextValue = {
  group: CustomGroup | undefined
  setGroup: React.Dispatch<React.SetStateAction<CustomGroup | undefined>>
  members: MemberMap
  setMembers: React.Dispatch<React.SetStateAction<MemberMap>>
  selectedMemberAliases: MemberAlias[] | undefined
  setSelectedMemberAliases: React.Dispatch<
    React.SetStateAction<MemberAlias[] | undefined>
  >
}

export const CustomGroupContext = createContext({} as CustomGroupContextValue)

interface Props {
  children: React.ReactNode
}

export function CustomGroupProvider(props: Props) {
  const [group, setGroup] = useState<CustomGroup>()
  const [members, setMembers] = useState<MemberMap>({})
  const [selectedMemberAliases, setSelectedMemberAliases] = useState<
    MemberAlias[] | undefined
  >()

  return (
    <CustomGroupContext.Provider
      value={{
        group,
        setGroup,
        members,
        setMembers,
        selectedMemberAliases,
        setSelectedMemberAliases,
      }}
    >
      {props.children}
    </CustomGroupContext.Provider>
  )
}

export function useCreateCustomGroup() {
  return useContext<CustomGroupContextValue>(CustomGroupContext)
}
